import React, { useState, useEffect } from "react";

export const svg = `<svg width="32" height="32" viewbox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.517 27.238c6.352.03 12.149-5.18 12.149-11.518 0-6.931-5.797-11.722-12.149-11.72h-5.466C6.624 3.998 1.333 8.79 1.333 15.72c0 6.34 5.29 11.549 11.718 11.518h5.466Z" fill="#0079BE"></path><path d="M13.076 4.96C7.203 4.964 2.444 9.724 2.444 15.6c.001 5.875 4.76 10.635 10.633 10.636 5.875-.001 10.635-4.761 10.636-10.636 0-5.876-4.76-10.636-10.636-10.638ZM6.336 15.6a6.753 6.753 0 0 1 4.327-6.292V21.89a6.75 6.75 0 0 1-4.327-6.291Zm9.153 6.294V9.306a6.75 6.75 0 0 1 4.33 6.293 6.752 6.752 0 0 1-4.33 6.294Z" fill="#fff"></path><path d="M18.517 27.238c6.352.03 12.149-5.18 12.149-11.518 0-6.931-5.797-11.722-12.149-11.72h-5.466C6.624 3.998 1.333 8.79 1.333 15.72c0 6.34 5.29 11.549 11.718 11.518h5.466Z" fill="#0079BE"></path><path d="M13.076 4.96C7.203 4.964 2.444 9.724 2.444 15.6c.001 5.875 4.76 10.635 10.633 10.636 5.875-.001 10.635-4.761 10.636-10.636 0-5.876-4.76-10.636-10.636-10.638ZM6.336 15.6a6.753 6.753 0 0 1 4.327-6.292V21.89a6.75 6.75 0 0 1-4.327-6.291Zm9.153 6.294V9.306a6.75 6.75 0 0 1 4.33 6.293 6.752 6.752 0 0 1-4.33 6.294Z" fill="#fff"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
